export default __webpack_public_path__ + "static/media/bylinx-logo.a140d548.png";